export default {
  state: {
    errors: [],
    hasError: false,
  },
  getters: {
    errors: (state) => state.errors,
  },
  mutations: {
    setErrors: (state, payload) => {
      if (typeof payload === "string") {
        state.errors.push(payload);
      } else if (Array.isArray(payload)) {
        state.errors = payload;
      }
    },
  },
};
